import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PaymentElement } from '@stripe/react-stripe-js';
import * as Sentry from '@sentry/react';
const PaymentMethodForm = () => (_jsx(PaymentElement, { id: "payment", className: "payment", options: { layout: 'tabs', terms: { card: 'never' } }, onChange: event => {
        Sentry.setContext('paymentType', { paymentType: event.value.type });
    } }));
export default PaymentMethodForm;
